var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getEnv } from "@ledgerhq/live-env";
import network from "@ledgerhq/live-network/network";
/**
 * Batched request of nft metadata on the "ethereum" protocol
 *
 * ⚠️ ethereum protocol doesn't mean ethereum chain, you can see this
 * as the evm protocol instead, and you can specify a chainId
 * to request the metadata on any evm chain supported
 */
export const getNftMetadata = (input, params) => __awaiter(void 0, void 0, void 0, function* () {
    const { data } = yield network({
        method: "POST",
        url: `${getEnv("NFT_ETH_METADATA_SERVICE")}/v1/ethereum/${params.chainId}/contracts/tokens/infos`,
        data: input,
    });
    return data;
});
/**
 * Batched request of nft collection metadata on the "ethereum" protocol
 *
 * ⚠️ ethereum protocol doesn't mean ethereum chain, you can see this
 * as the evm protocol instead, and you can specify a chainId
 * to request the metadata on any evm chain supported
 */
export const getNftCollectionMetadata = (input, params) => __awaiter(void 0, void 0, void 0, function* () {
    const { data } = yield network({
        method: "POST",
        url: `${getEnv("NFT_ETH_METADATA_SERVICE")}/v1/ethereum/${params.chainId}/contracts/infos`,
        data: input,
    });
    return data;
});
export default {
    getNftMetadata,
    getNftCollectionMetadata,
};
//# sourceMappingURL=index.js.map